<ion-row class="ion-justify-content-center">
  @if (!hideButtons) {
    <ion-col size="2">
      <div (click)="removeDays(1)" class="button left pointer">
        <ion-icon color="light" class="caret left-caret" name="arrow-back-outline"></ion-icon>
      </div>
    </ion-col>
  }
  <ion-col class="ion-text-center date-style">
    <ion-datetime-button [datetime]="'datePicker_' + id"></ion-datetime-button>

    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime
          locale="nl-NL"
          [id]="'datePicker_' + id"
          presentation="date"
          showDefaultButtons="true"
          [doneText]="'dateTimeModal.confirmButton' | translate"
          [cancelText]="'dateTimeModal.closeButton' | translate"
          [value]="date.toISOString()"
          [min]="minDate ? minDate.toISOString() : oldDate.getFullYear()"
          [max]="maxDate ? maxDate.toISOString() : date.getFullYear() + maxYearsInFuture"
          (ionChange)="onDateChanged($event['detail']['value'], true)"
        ></ion-datetime>
      </ng-template>
    </ion-modal>
  </ion-col>
  @if (!hideButtons) {
    <ion-col size="2">
      <div (click)="addDays(1)" class="button right pointer">
        <ion-icon color="light" class="caret" name="arrow-forward-outline"></ion-icon>
      </div>
    </ion-col>
  }
</ion-row>
